<div class="bp-modal mod-lg wrapper">
	<bp-modal-header
		[title]="'send_to_CRYPTOSYMBOL_contact' | translate: [selectedCryptocoin.name]"
		class="font-semibold">
		<a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
			{{ "back" | translate }}
		</a>
		<a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
			{{ "cancel" | translate }}
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="bp-modal-description description-title">
				{{ "multichain_choose_network_title" | translate }}
			</div>
			<div class="bp-modal-description check-network">
				{{ "multichain_check_info_network" | translate }}
			</div>
			<div class="bp-modal-description info">
				<div class="bpi__icon-attention"></div>
				<div class="no-hyphens">{{ "deposit_multichain_info" | translate }}</div>
			</div>

			<div class="network-list">
				<network-list
					class="network-list"
					(onSelectNetwork)="selectNetwork($event)"
					[availableNetworks]="availableNetworks"
					[unavailableNetworks]="unavailableNetworks"
					[selectedCryptocoin]="selectedCryptocoin">
				</network-list>
			</div>
		</div>
	</div>
</div>
